
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/treasure",
      function () {
        return require("private-next-pages/treasure.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/treasure"])
      });
    }
  